import React, { useState } from "react";
import "./Hero.css";
import ContactModal from "../Modal/ContactModal";
import { Button } from "react-bootstrap";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPhone } from "@fortawesome/free-solid-svg-icons";


function Hero() {
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <section id="hero" className="hero d-flex align-items-center">
        <div className="container-fluid px-5">
          <div className="row align-items-center justify-content-between">
            <div className="col-xl-5 col-lg-6 text-center hero-left">
              <img src="/girl4.png" alt="HotLine Numbers" className="img-fluid girl-img" />
            </div>

            <div className="col-xl-6 col-lg-6 hero-text text-lg-start text-center mt-5 mt-lg-0 fade-in-up">
              <div className="mb-1 trusted">
                <img src="/baloon.png" className="baloon-img" alt="HotLine Numbers" />
                <h1 className="display-3 fw-bold mb-3 lh-sm hash">#1</h1>
              </div>

              <div className="fade-in-left">
                <h1 className="display-3 fw-bold mb-3 lh-sm text">
                  SRI LANKA’S<br />
                  <span className="vip">VIP NUMBER PROVIDER</span>
                </h1>
                <p className="tagline mb-2 fade-in-up">YOUR BUSINESS STARTS WITH THE RIGHT NUMBER</p>
                <p className="description mb-4 fade-in-up">
                  Premium Mobile Numbers for Startups and Business Owners
                </p>
              </div>

              {/* React Bootstrap Button */}
              <Button
                onClick={() => setShowModal(true)}
                className="px-5 py-3 border border-white bg-transparent text-white rounded-full font-semibold text-base transition duration-300 contact-btn-custom"
                style={{ cursor: "pointer" }}
              >
                Contact Us
              </Button>

              {/* <Button
                href="/numbers"
                className="px-5 py-3 border border-white bg-white rounded-full font-semibold text-base transition duration-300 browse-numbers-btn"
                style={{ cursor: "pointer" }}
              >
                Browse Numbers
              </Button> */}

              <div className="fade-in-left">
                <h1 className="display-3 fw-bold mt-5 lh-sm">
                  <span className="hotline">
                    {/* <FontAwesomeIcon icon={faPhone} className="me-2 phone-icon" /> */}
                    Hotline: 072 722 72 72
                  </span>


                </h1>
              </div>

            </div>
          </div>
        </div>
      </section>

      {/* Contact Modal */}
      <ContactModal show={showModal} handleClose={() => setShowModal(false)} />
    </>
  );
}

export default Hero;
